import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { AdvisorsToolbar } from '@src/components/sco/Advisors/layout/AdvisorsToolbar';
import { useAdvisorsBelowToolbar } from '@src/components/sco/Advisors/layout/AdvisorsToolbarExtras';
import { BreadcrumbItem } from '@src/contexts/ActiveContentContext';
import { ReactNode } from 'react';
type AdvisorsMainPanelProps = {
  breadcrumbs?: BreadcrumbItem[];
  children: ReactNode;
  showAside?: boolean;
};
export const AdvisorsMainPanel = t0 => {
  const $ = _c(11);
  const {
    breadcrumbs,
    children,
    showAside
  } = t0;
  const belowToolbar = useAdvisorsBelowToolbar();
  let t1;
  if ($[0] !== breadcrumbs || $[1] !== showAside) {
    t1 = <AdvisorsToolbar breadcrumbs={breadcrumbs} showAside={showAside} />;
    $[0] = breadcrumbs;
    $[1] = showAside;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== belowToolbar) {
    t2 = belowToolbar ? <Box flexShrink={0} width="full">{belowToolbar}</Box> : null;
    $[3] = belowToolbar;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children) {
    t3 = <Box display="flex" flex={1} flexDirection="column" minHeight={0} overflow="hidden" width="full">{children}</Box>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <VStack align="stretch" alignSelf="stretch" gap={0} height="full" justify="stretch" justifySelf="stretch" maxHeight="100%" minHeight={0} width="full">{t1}{t2}{t3}</VStack>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};